// src/pages/projects/container/ProjectDescription.jsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const ProjectDescription = ({ description }) => {
  const theme = useTheme();
  
  if (!description) return null;
  
  return (
    <Box 
      sx={{ 
        px: 3,
        py: 2,
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}` 
      }}
    >
      <Typography variant="body2">
        {description}
      </Typography>
    </Box>
  );
};

export default ProjectDescription;